import { vysionTrack } from './vysionService';

const setSearchVysion = (param: any): void => {
  switch (param.event) {
    case 'APPLY FILTERS':
      vysionTrack(param, 'search-applyFilters');
      break;
    case 'RESET FILTERS':
      vysionTrack(param, 'search-resetFilters');
      break;
    default:
      return;
  }
};

export { setSearchVysion };
